<h2 mat-dialog-title>Editar movimiento</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Tipo de movimiento</mat-label>
        <mat-select [(ngModel)]="form.tipoMovimiento">
          <mat-option *ngFor="let tipo of tiposMovimiento" [value]="tipo">{{ tipo }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Fecha</mat-label>
        <input matInput type="datetime-local" [(ngModel)]="form.fechaMovimiento" />
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Buscar/cambiar equipo</mat-label>
        <input matInput [(ngModel)]="textoBusquedaEquipo" (input)="onBuscarEquipo($event)"
               placeholder="Buscar por modelo o número de serie" />
      </mat-form-field>
      <div *ngIf="equiposEncontrados.length > 0" class="list-group">
        <button type="button" class="list-group-item list-group-item-action" *ngFor="let eq of equiposEncontrados"
                (click)="seleccionarEquipo(eq)">
          {{ eq.tipo }} - {{ eq.marca }} {{ eq.modelo }} (S/N: {{ eq.numeroSerie }})
        </button>
      </div>
      <div *ngIf="equipoActual" class="text-muted mt-1">
        Equipo actual: {{ equipoActual.tipo }} - {{ equipoActual.marca }} (S/N original: {{ equipoActual.numeroSerie }})
      </div>
    </div>

    <ng-container *ngIf="equipoActual">
      <div class="col-6">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Modelo del equipo actual</mat-label>
          <input matInput [(ngModel)]="equipoModeloEditado" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>N° serie del equipo actual</mat-label>
          <input matInput [(ngModel)]="equipoNumeroSerieEditado" (blur)="onNumeroSerieEditadoBlur()" />
        </mat-form-field>
        <div *ngIf="equiposSimilaresEncontrados.length > 0" class="alert alert-warning p-2">
          <small>¿Es este equipo? Ya existe uno muy parecido:</small>
          <div class="list-group">
            <button type="button" class="list-group-item list-group-item-action" *ngFor="let eq of equiposSimilaresEncontrados"
                    (click)="usarEquipoSimilar(eq)">
              {{ eq.tipo }} - {{ eq.marca }} {{ eq.modelo }} (S/N: {{ eq.numeroSerie }})
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Observación</mat-label>
        <input matInput [(ngModel)]="form.observacion" />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" type="button" [disabled]="guardando" (click)="guardar()">Guardar</button>
</mat-dialog-actions>
